/**
 * When a zero balance is allowed to block a button.
 *
 * Admin accounts are never blocked: sending credits ISSUES them (nothing is
 * taken from the admin's own wallet), and activating an admin's own device
 * tops itself up first. The server enforces both — these helpers only stop the
 * UI disabling buttons that would in fact work.
 *
 * The rules live here rather than inline so the activation prompt, the
 * send-credits modal and their tests all read from one definition.
 */

/** Can this account activate or renew a device licence right now? */
export const hasSpendableCredit = (
   credits: number,
   unlimited?: boolean
): boolean => !!unlimited || credits > 0;

/** Is the amount typed into the send-credits box sendable? */
export const isSendAmountValid = (
   amount: number,
   balance: number,
   unlimited?: boolean
): boolean =>
   Number.isInteger(amount) && amount >= 1 && (!!unlimited || amount <= balance);

/**
 * Should a distributor recipient block the send?
 *
 * Ordinary users may not transfer into a distributor wallet — that would be a
 * free refuel and reopens a points-farming loop. An admin issuing credits is
 * not that, so the rule does not apply to them.
 */
export const blocksDistributorRecipient = (
   recipientIsDistributor: boolean,
   unlimited?: boolean
): boolean => recipientIsDistributor && !unlimited;
